import React from 'react'
import { Pane, TextInput } from 'evergreen-ui'
import brace from 'brace';
import AceEditor from 'react-ace';

import 'brace/mode/lua';
import 'brace/theme/github';

export const Formula = ({ field }) => {
    return <Pane>
        {/* <AceEditor
            mode="lua"
            theme="github"
            value={field.content}
            onChange={val => field.content = val}
            editorProps={{ $blockScrolling: true }}
        /> */}
        <TextInput
            placeholder="Section formula"
            value={field.content}
            onChange={e => field.content = e.target.value}
        />
    </Pane>
} 